"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BikeOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var BikeOutlineSVG = function BikeOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M24.5,15a5.42,5.42,0,0,0-1.52.22l-1-1.86V9h2a1,1,0,0,0,0-2H19a1,1,0,0,0,0,2h1v3H12V10h1a1,1,0,0,0,0-2H9a1,1,0,0,0,0,2h1v3.36L9,15.22A5.42,5.42,0,0,0,7.5,15,5.5,5.5,0,1,0,13,21h2.1a1,1,0,0,0,.89-.53L19,14h1l1.16,2.14A5.49,5.49,0,1,0,24.5,15Zm-17,9a3.5,3.5,0,0,1,0-7,3.55,3.55,0,0,1,.56.06L6.71,19.62a.91.91,0,0,0,0,.93A1,1,0,0,0,7.6,21H11A3.51,3.51,0,0,1,7.5,24Zm3.15-5H9l.71-1.19A3.76,3.76,0,0,1,10.65,19Zm3.85,0H12.79a5.53,5.53,0,0,0-2-2.92L12,14h5Zm10,5a3.49,3.49,0,0,1-2.37-6.06l1.38,2.53a1,1,0,0,0,.89.53,1,1,0,0,0,.45-.1.93.93,0,0,0,.44-1.28l-1.35-2.56A3.49,3.49,0,1,1,24.5,24Z"
  }));
};
exports.BikeOutlineSVG = BikeOutlineSVG;
BikeOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(BikeOutlineSVG);
exports.default = _default;